<template>
  <section class="shop-section">
    <b-container class="position-relative">
      <b-row>
        <b-col sm="12" md="6">
         <div class="shop-section-content">
           <h4 class="shop-section-title" v-html="$t('web_marker_title')"></h4>
           <p class="shop-section-msg"  v-html="$t('web_marker_msq')"></p>
         </div>
        </b-col>
        <b-col sm="12" md="6">
         <div class="web-market-btn-container">
           <b-button class="market-btn apple-market-btn" disabled v-b-modal.modal-center><img class="subscribe-icon bg-icon-1" src="../assets/img/android-icon.svg" alt="Registration image"></b-button>
           <b-button class="market-btn android-market-btn" disabled v-b-modal.modal-center><img class="subscribe-icon bg-icon-1" src="../assets/img/apple-icon.svg" alt="Registration image"></b-button>
         </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.shop-section{
  background: #DADFE2;
  padding: 80px 0;
  .shop-section-content{
    .shop-section-title{
      color: #30394B;
      font-family: $main-font;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 38.4px;
      margin: 0 0 24px 0;
      @media screen and (min-width: 320px) {
        font-size: 24px;
        line-height: 28.8px;
      }
      @media screen and (min-width: 768px) {
        font-size: 18px;
        line-height: 21.6px;
      }
      @media screen and (min-width: 992px) {
        font-size: 32px;
        line-height: 38.4px;
      }
    }
    .shop-section-msg{
      color: #30394B;
      font-family: $main-font;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 40px;
      }
      @media screen and (min-width: 768px) {
        max-width: 374px;
        font-size: 18px;
        line-height:  27px;
        margin: 0;
      }
      @media screen and (min-width: 992px) {
        max-width: 496px;
        font-size: 18px;
      }
    }
  }
  .web-market-btn-container{
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 16px;
    @media screen and (min-width: 320px) {
      justify-content: flex-start;
    }
    @media screen and (min-width: 768px) {
      justify-content: flex-end;
    }
    .market-btn{
      width: 92px;
      height: 92px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      background: #ffffff;
      border: 2px solid #000;
      img{
        width: 65px;
        height: 65px;
      }
    }
  }
}

</style>
